module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/CA-a57b8cfc7219359dc1a70d3afe283b45.png";